import { Heading } from 'braid-design-system';

export const PaymentHeading = () => (
  <Heading level="3">Payment Details</Heading>
);
